import { ILanguageOption } from "../interfaces";

export const sortTranslatedOptions = <T extends ILanguageOption>(
  options: T[],
  language?: string,
  opts: Intl.CollatorOptions = { sensitivity: "base", numeric: true },
): T[] => {
  const arr = [...options];

  arr.sort((a, b) => {
    const aLabel = (a.label ?? "").toString();
    const bLabel = (b.label ?? "").toString();

    // primary locale-aware sort by translated label
    const cmp = aLabel.localeCompare(bLabel, language, opts);

    // if labels are not equal, use the primary ordering
    if (cmp !== 0) {
      return cmp;
    }

    // if labels are equal, use 'code' as a deterministic tiebreaker without a specific language so it uses the runtime default locale
    const aCode = (a.code ?? "").toString();
    const bCode = (b.code ?? "").toString();
    return aCode.localeCompare(bCode, undefined, { sensitivity: "base" });
  });

  return arr;
};
